import React from "react";
import '../styles/home.css';
import Translator from "../services/Translator";


export default function Information({lang, user, screen, securityStatus}: any) {
    return (
        <div id="home" style={{display: user === null || screen !== 'information' ? 'none' : 'block'}}>
            <div className="container">
                <div className="row">
                    {
                        securityStatus.type === 0 ? (
                            <div className="container" style={{marginTop: '5px'}}>
                                <div className="row">
                                    <div className="col">
                                        <div className="alert alert-success">
                                            <strong>{Translator.trans(lang, 'security_status.empty')}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : ''
                    }

                    {
                        securityStatus.type === 2 ? (
                            <div className="container" style={{marginTop: '5px'}}>
                                <div className="row">
                                    <div className="col">
                                        <div className="alert alert-danger">
                                            <strong>{Translator.trans(lang, 'security_status.danger')}</strong>
                                            &nbsp;{securityStatus.comment !== null ? securityStatus.comment : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : ''
                    }

                    {
                        securityStatus.type === 1 ? (
                            <div className="container" style={{marginTop: '5px'}}>
                                <div className="row">
                                    <div className="col">
                                        <div className="alert alert-warning">
                                            <strong>{Translator.trans(lang, 'security_status.warning')}</strong>
                                            &nbsp;{securityStatus.comment !== null ? securityStatus.comment : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : ''
                    }

                    {
                        securityStatus.type === -1 && securityStatus.comment !== null ? (
                            <div className="container" style={{marginTop: '5px'}}>
                                <div className="row">
                                    <div className="col">
                                        <div className="alert alert-info">
                                            {securityStatus.comment}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : ''
                    }
                </div>
            </div>
        </div>
    );
}
